import { bind, Component, h, signal, tag } from "omi";
import classNames from "classnames";
import isEmpty from "lodash-es/isEmpty";

import { closeModal, NWIcon, NWTooltip, openProModal } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {
  onChange: (text: string) => void;
  url: string | undefined;
  error?: string;
};

@tag("share-ui-document-url")
export class DocumentURL extends Component<Props> {
  static css = [tailwind];

  private urlInput = signal<string | undefined>(undefined);

  receiveProps(props: Props) {
    this.urlInput.value = props.url;
  }

  @bind
  private handleOnInputChange(event: Event) {
    if (!Store.user.isPro()) {
      closeModal();
      setTimeout(() => openProModal("project_share_url"), 300);
      return;
    }

    const target = event.target as HTMLInputElement;
    this.urlInput.value = target.value;
    this.props.onChange(target.value);
  }

  render() {
    const hasError = !isEmpty(this.props.error);
    const isPro = Store.user.isPro();

    return (
      <div className="flex flex-col w-full items-start h-10 bg-white shadow-xs">
        <div className="relative inline-flex w-full">
          <input
            className={classNames("py-2 pl-4 pr-9 w-full z-20 rounded-lg outline-none transition-all border", {
              "border-error-300 focus:shadow-xse focus:border-error-600": hasError,
              "border-gray-300 focus:shadow-xss focus:border-brand-400": !hasError,
            })}
            placeholder="youruniquelink.com"
            maxLength="2048"
            tabIndex={1}
            onInputCapture={this.handleOnInputChange}
            value={this.urlInput.value}
            disabled={!isPro}
          />
          <div className="absolute right-3 z-[21] flex items-center justify-center h-10">
            <div class="text-quaternary cursor-pointer w-fit h-fit">
              <NWTooltip
                strategy="absolute"
                content="Add to your documentation's title page"
                placement="top"
                arrow={true}
                maxWidth={"200px"}
              >
                <NWIcon name="help" width={16} height={16} />
              </NWTooltip>
            </div>
          </div>
        </div>
        {hasError && <label className={classNames("text-xs mt-1.5 text-error-600")}>{this.props.error}</label>}
      </div>
    );
  }
}
